import { useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, AccordionToggleEventHandler, Title3 } from '@fluentui/react-components';

import { useSignInState } from './signInState';

import ModuleConfigIntuneReporting from './ModuleConfigs/Module-IntuneReporting';
import ModuleWUfBReporting from './ModuleConfigs/Module-WUfBReporting';
import ModuleDellWarranty from './ModuleConfigs/Module-DellWarranty';
import ModuleLenovoWarranty from './ModuleConfigs/Module-LenovoWarranty';
import ModuleNISTAPI from './ModuleConfigs/Module-NISTConfig';
import ModuleSurfaceWarranty from './ModuleConfigs/Module-SurfaceWarranty';
//import more feature configuration components here

const featureConfiguration = () => {
    const { signInState } = useSignInState();

    const [openItems, setOpenItems] = useState(["0"]);
    const handleToggle: AccordionToggleEventHandler<string> = (event, data) => {
        setOpenItems(data.openItems);
    };

    const checkModule = useCallback((moduleName: string): boolean => {
        return signInState.licenseInfo.some(license =>
            license.CustomerID === signInState.currentCustomerID &&
            license.modules.some(module => module.name === moduleName)
        );
    }, [signInState]);

    useEffect(() => {
        setOpenItems(["0"]);
    }, [signInState.currentCustomerID]);

    return (
        <div style={{ marginLeft: '20px' }}>
            {/* Depending on licensed features, render appropriate feature configurations under accordions */}
            <Accordion
                openItems={openItems}
                onToggle={handleToggle}
                collapsible
            >
                {checkModule('Reporting_Intune') &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="1">
                        <AccordionHeader>Intune & Entra Reporting Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleConfigIntuneReporting />
                        </AccordionPanel>
                    </AccordionItem>
                }
                {checkModule('Reporting_Intune') &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="2">
                        <AccordionHeader>WUfB Reporting Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleWUfBReporting />
                        </AccordionPanel>
                    </AccordionItem>
                }
                {checkModule('Reporting_Intune') &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="3">
                        <AccordionHeader>Dell Warranty Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleDellWarranty />
                        </AccordionPanel>
                    </AccordionItem>
                }
                {checkModule('Reporting_Intune') &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="4">
                        <AccordionHeader>Lenovo Warranty Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleLenovoWarranty />
                        </AccordionPanel>
                    </AccordionItem>
                }
                {checkModule('Reporting_Intune') && signInState.featureFlags?.some((flag: any) => flag.FeatureName === 'SurfaceWarranty' && flag.IsEnabled) &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="surface-warranty">
                        <AccordionHeader>Surface Warranty Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleSurfaceWarranty />
                        </AccordionPanel>
                    </AccordionItem>
                }
                       {checkModule('Reporting_Intune') &&
                    <AccordionItem disabled={!checkModule('Reporting_Intune')} value="5">
                        <AccordionHeader>NIST API Configuration</AccordionHeader>
                        <AccordionPanel>
                            <ModuleNISTAPI />
                        </AccordionPanel>
                    </AccordionItem>
                }
                {(checkModule('M365LCM_Intune') || checkModule('M365LCM_CA')) &&
                    <AccordionItem disabled={!(checkModule('M365LCM_Intune') || checkModule('M365LCM_CA'))} value="5">
                        <AccordionHeader>Lifecycle Management Configuration</AccordionHeader>
                        <AccordionPanel>
                            LCM Configuration Details
                            Coming soon...
                        </AccordionPanel>
                    </AccordionItem>
                }
                {checkModule('AVD_Base') &&
                    <AccordionItem disabled={!checkModule('AVD_Base')} value="6">
                        <AccordionHeader>Azure Virtual Desktop Configuration</AccordionHeader>
                        <AccordionPanel>
                            AVD Configuration Details
                            Coming soon...
                        </AccordionPanel>
                    </AccordionItem>
                }
            </Accordion>
        </div>
    );
}

export default featureConfiguration;